<rid-categorise
  class="h-dvh"
  name="Sorteren (gemengd)"
  [questions]="[
    {
      id: '1',
      assignment: 'Sleep het woord op de juiste afbeelding',
      item: { type: 'WORD', word: 'tijger' },
      options: [
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BJuCpMZwjLRDH22qN_3C-.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/tRbHTlab4z8VFbpW_d-7z.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/EnNEt6JxcpmKOEZK0mbG9.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
      ],
      answer: 1,
    },
    {
      id: '2',
      assignment: 'Sleep het woord op de juiste afbeelding',
      item: { type: 'WORD', word: 'zebra' },
      options: [
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/BJuCpMZwjLRDH22qN_3C-.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/EnNEt6JxcpmKOEZK0mbG9.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
        },
        {
          type: 'CONTENT',
          image: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/tRbHTlab4z8VFbpW_d-7z.png',
          audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
        },
      ],
      answer: 1,
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/categorise'])"
/>
